import { memo } from 'react';
import { cn, List, RawHtml } from '@divlab/divanui';

import useMedias from '@Hooks/useMedias';
import styles from './ServiceTable.module.css';

import type { FC, TableHTMLAttributes } from 'react';

export interface ColumnData {
  name: string;
  price: string;
}

export interface ServiceTableProps extends TableHTMLAttributes<HTMLTableElement> {
  className?: string;
  contentData: ColumnData[];
}

const ServiceTable: FC<ServiceTableProps> = (props) => {
  const { className, contentData, ...restProps } = props;
  const { isMobile } = useMedias();

  if (isMobile) {
    const rows: ColumnData[][] = [];

    for (let i = 0; i < contentData.length; i += 2) {
      rows.push(contentData.slice(i, i + 2));
    }

    return (
      <List
        {...restProps}
        className={cn(styles.table, className)}
        items={rows}
        renderChild={(row: ColumnData[]) => {
          const titles = row.map((item) => item.name);
          const contents = row.map((item) => item.price);

          return (
            <>
              <div className={styles.tr}>
                {titles.map((title, index) => (
                  <div className={cn(styles.td, styles.cellTitle)} key={index}>
                    <RawHtml html={title} />
                  </div>
                ))}
              </div>

              <div className={styles.tr}>
                {contents.map((cont, index) => (
                  <div className={cn(styles.td, styles.cellDescription)} key={index}>
                    <RawHtml html={cont} />
                  </div>
                ))}
              </div>
            </>
          );
        }}
      />
    );
  }

  const titles: string[] = [];
  const contents: string[] = [];

  contentData.forEach((defaultColumn) => {
    titles.push(defaultColumn.name);
    contents.push(defaultColumn.price);
  });

  return (
    <div {...restProps} className={cn(styles.table, className)}>
      <List
        {...restProps}
        className={styles.tr}
        items={titles}
        renderChild={(title: string) => {
          return (
            <div className={cn(styles.td, styles.rowTitle)}>
              <div className={styles.row}>
                <RawHtml html={title} />
              </div>
            </div>
          );
        }}
      />
      <List
        {...restProps}
        className={styles.tr}
        items={contents}
        renderChild={(item: string, index) => {
          return (
            <div className={cn(styles.td, styles.rowDescription)} data-title={titles[index]}>
              <div className={styles.row}>
                <RawHtml html={item} />
              </div>
            </div>
          );
        }}
      />
    </div>
  );
};

export default memo(ServiceTable);
